import { createApiReducers, createApiReducerInitialState } from '../../../../../Helpers/reducer'
import { GET_ACTIVE_EVAL_FORMS } from './evalFormFields.constants'

const initialState = {
  ...createApiReducerInitialState('activeEvalForms', []),
}

export default (state = initialState, action) => {
  const reducers = {
    ...createApiReducers(GET_ACTIVE_EVAL_FORMS, 'activeEvalForms', [], true),
  }

  return reducers[action.type] ? reducers[action.type](state, action) : state
}
